import SignupCancelledModal from './SignupCancelledModal';

export default SignupCancelledModal;


// WEBPACK FOOTER //
// ./src/components/SignupCancelledModal/index.jsx